import { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import { ElementsMapping, QuestionnaireContextCommonValues, QuestionnaireForm } from "./context";
import { Post } from "src/api/client-api/post/postSchema";
import { QueryObserverResult } from "react-query";
import { useState } from "react";
import { selectIngredientGenericValues } from "./utils/selectIngredientGenericValues";

export type QuestionnaireContextProviderProps = QuestionnaireContextCommonValues & {
    ssqVersion?: SsqVersion;
    postQuery: QueryObserverResult<Post | undefined>;
    children: ReactNode;
};
export const QuestionnaireFormContextProvider = (props: QuestionnaireContextProviderProps) => {
    const { children, ssqVersion, postQuery, ...items } = props;

    const { data: post, isLoading: isPostLoading, refetch: refetchPost, isError: isPostError } = postQuery;

    const elementsByPropertyId: ElementsMapping = Object.groupBy(post?.elements ?? [], (i) => i.ssqPropertyId);
    const ingredientGenericValues = selectIngredientGenericValues(
        ssqVersion?.ingredientGenericValues,
        items.ingredientReferenceId,
    );

    const canEdit = props.canEdit && !post?.isLocked;
    const [openUnitConverterKey, setOpenUnitConverterKey] = useState<string | null>(null);

    const values = {
        ssqVersion,
        isSsqVersionLoading: ssqVersion === undefined,
        post,
        isPostLoading,
        isPostError,
        refetchPost,
        elementsByPropertyId,
        ingredientGenericValues,
        openUnitConverterKey,
        setOpenUnitConverterKey,

        ...items,

        canEdit,
    };

    return <QuestionnaireForm.Provider value={values}>{children}</QuestionnaireForm.Provider>;
};
